import { Text, View } from 'react-native'
import { TriangleAlert } from 'lucide-react-native'
import { colors } from '@chillout/core'

interface SectionErrorStateProps {
  message: string
  retryLabel: string
  onRetry: () => void
}

export function SectionErrorState({ message, retryLabel, onRetry }: SectionErrorStateProps) {
  return (
    <View className="items-center px-4 py-8 sm:py-10">
      <View className="h-20 w-20 items-center justify-center rounded-full bg-accent/10">
        <TriangleAlert size={34} color={colors.accent.DEFAULT} strokeWidth={1.8} />
      </View>
      <Text className="mt-4 text-center text-xl font-bold text-primary">{message}</Text>
      <Text
        className="mt-3 text-center text-base font-medium text-accent"
        accessibilityRole="link"
        onPress={onRetry}
      >
        {retryLabel}
      </Text>
    </View>
  )
}
